/* eslint import/no-extraneous-dependencies: "off" */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const ProgressWrapperStyle = styled.div`
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  ${(props) => props.theme.progress.style};
`;

interface ProgressWrapperProps {
  children: React.ReactNode;
}

const ProgressWrapper: React.FunctionComponent<ProgressWrapperProps> = ({ children }) => (
  <ProgressWrapperStyle>{children}</ProgressWrapperStyle>
);

export default ProgressWrapper;
